const size = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '414px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
  heightXS: '480px',
  heightS: '568px',
  heightM: '768px',
  heightL: '1024px'
};

export const device = {
  mobileS: `(min-width: ${size.mobileS})`,
  mobileM: `(min-width: ${size.mobileM})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  desktopL: `(min-width: ${size.desktop})`,
  maxMobileS: `(max-width: ${size.mobileS})`,
  maxMobileM: `(max-width: ${size.mobileM})`,
  maxMobileL: `(max-width: ${size.mobileL})`,
  maxTablet: `(max-width: ${size.tablet})`,
  maxLaptop: `(max-width: ${size.laptop})`,
  maxLaptopL: `(max-width: ${size.laptopL})`,
  maxDesktop: `(max-width: ${size.desktop})`,
  maxDesktopL: `(max-width: ${size.desktop})`,
  heightXS: `(min-height: ${size.heightXS})`,
  heightS: `(min-height: ${size.heightS})`,
  heightM: `(min-height: ${size.heightM})`,
  heightL: `(min-height: ${size.heightL})`,
  maxHeightXS: `(max-height: ${size.heightXS})`,
  maxHeightS: `(max-height: ${size.heightS})`,
  maxHeightM: `(max-height: ${size.heightM})`
};
